import { useSelector, useDispatch } from "react-redux";
import { setShowAuth } from "../../store/slice/UISlice";
import { Dialog, DialogContent } from "@mui/material";
import LoginBox from "./LoginBox";
import RegistrationBox from "./RegistrationBox";
import { useState } from "react";

const Auth = ({ isMobile }) => {

    const dispatch = useDispatch();
    const showAuth = useSelector((state) => state.ui.showAuth);
    const isAuth = useSelector((state) => state.user.isAuth);
    const [isLogin, setIsLogin] = useState(true);
    const toggleAuthMode = () => {
        setIsLogin(!isLogin);
    };

    if (isAuth) {
        return null;
    }

    return (
        <>
            <Dialog open={showAuth} onClose={() => dispatch(setShowAuth(false))} fullWidth={true} maxWidth="xs">
                <DialogContent>
                    {isLogin ?
                        <LoginBox
                            isMobile={isMobile}
                            toggleAuthMode={toggleAuthMode}
                            onSuccess={() => dispatch(setShowAuth(false))}
                        /> :
                        <RegistrationBox
                            isMobile={isMobile}
                            toggleAuthMode={toggleAuthMode}
                            onSuccess={() => dispatch(setShowAuth(false))}
                        />
                    }
                </DialogContent>
            </Dialog>
        </>
    );
};

export default Auth;